module.exports = __webpack_public_path__ + "static/media/dim3supreme1.f1e5e70c.jpg";